import { useReducer, Dispatch, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { APIHookResponse } from './types';
import { NONE } from '~/constants';
import { ActionConstructor } from '~/store/types';

const isUnset = (value: any) => [undefined, null].includes(value);

export const useAPIReducer = (
  dispatchAction: ActionConstructor,
  params = {},
) => {
  const dispatch = useDispatch();
  return getAPIReducer(dispatch, dispatchAction, params);
};

export const getAPIReducer = (
  dispatch: Dispatch<any>,
  dispatchAction: ActionConstructor,
  params = {},
) => {
  const initial = { loading: true, data: NONE, error: NONE };
  const reducer = (state: any, action: any) => {
    if (action.loading !== undefined) {
      return {
        data: null,
        error: null,
        loading: true,
      };
    }
    if (!isUnset(action.error)) {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }
    if (!isUnset(action.data)) {
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    }
    return state;
  };

  const useAPI = (data: any = NONE, error: any = NONE): APIHookResponse => {
    const [response, setResponse] = useReducer(reducer, initial);
    useEffect(() => {
      setResponse({ loading: true });
      dispatch(dispatchAction(params));
    }, []);
    useEffect(() => setResponse({ data }), [data]);
    useEffect(() => setResponse({ error }), [error]);
    return response;
  };
  return useAPI;
};
